import { graphql } from "gql.tada";
import { LinkFragment } from "./LinkFragment";

export const TitleSectionFragment = graphql(
  `
    fragment TitleSectionFragment on TitleSection {
      sys {
        id
      }
      superText
      title
      subText
      cta {
        ...LinkFragment
      }
    }
  `,
  [LinkFragment]
);
